import { useMemo } from 'react';

import useWindowSize from 'apps/web_forms/hooks/useWindowSize';

const formElementSelector = 'form[data-testid="form"]';

/**
 * @returns {string} css padding value
 */
const getFormPadding = () => {
  const defaultValue = '18px';

  const formElement = document.querySelector(formElementSelector);
  const computedStyle =
    formElement && window.getComputedStyle(formElement)?.paddingLeft;
  const paddingIfPresent = computedStyle != null ? computedStyle : defaultValue;
  // If we're not in a form, the form element isn't present, so there's no padding
  return formElement ? paddingIfPresent : 0;
};

/**
 * @returns {string} css padding value
 */
const useFormPadding = () => {
  const formElementExists = !!document.querySelector(formElementSelector);
  const windowSize = useWindowSize();
  const formPadding = useMemo(getFormPadding, [windowSize, formElementExists]);
  return formPadding;
};

export { useFormPadding };
export default useFormPadding;
